// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-snack[data-v-1501f7ae]:not(.v-snack--absolute) {\n  height: 100vh;\n  position: fixed;\n  z-index: 999999999999;\n}\n", ""]);
// Exports
module.exports = exports;
